module.exports = __webpack_public_path__ + "img/Franceinfo.d409b073.svg";